import React from 'react';
import request from '../../request';
import Input from '../shared/labelInput';
import Select from '../shared/select';
import Checkbox from '../shared/checkbox';

export default class EditUser extends React.Component {
  constructor({ match }) {
    super();
    this.state = {
      user: JSON.parse(localStorage.getItem('user' + match.params.id) || '{}'),
      loading: true,
      companies: [],
      selectedCompanies: [],
    };
  }

  async sendPassword() {
    let { match } = this.props;
    let response = await request({
      url: `settings/users/${match.params.id}/resend-password`,
      method: 'POST',
    });
    if (response.message) alert(response.message);
  }

  async componentDidMount() {
    let { match } = this.props;
    try {
      let { user, role, companies, selectedCompanies, reset } = await request({
        url: `settings/users/${match.params.id}`,
      });
      localStorage.setItem('user' + match.params.id, JSON.stringify(user));
      this.setState({
        user,
        role,
        token: reset && reset.token ? reset.token : '',
        companies,
        selectedCompanies,
        loading: false,
      });
    } catch (e) {
      this.setState({ error: e.message || e, loading: false });
    }
  }

  async save() {
    let { match } = this.props;
    let { user, selectedCompanies, role } = this.state;
    try {
      this.setState({ loading: true });
      let response = await request({
        url: `settings/users/${match.params.id}`,
        method: 'PATCH',
        body: { ...user, role, selectedCompanies },
      });

      this.setState({
        user: { ...response, password: null, password_confirm: null },
        loading: false,
        error: null,
      });
    } catch (e) {
      this.setState({
        loading: false,
        error: e.message || e,
        user: { ...this.state.user, password: null, password_confirm: null },
      });
    }
  }

  toggleCompany(id) {
    let { selectedCompanies } = this.state;
    let index = selectedCompanies.findIndex(company => company === id);
    if (index !== -1) selectedCompanies.splice(index, 1);
    else selectedCompanies.push(id);
    this.setState({ selectedCompanies });
  }

  render() {
    let isAdmin = localStorage.getItem('type') === 'admin';

    let { match } = this.props;
    let {
      user,
      loading,
      error,
      role,
      companies,
      selectedCompanies,
    } = this.state;
    return (
      <div id="dashboard" style={{ opacity: loading ? 0.5 : 1 }}>
        <h5 className="heading">Edit</h5>
        {error ? <p className="error">{error}</p> : null}
        <Input
          name="first_name"
          label="First Name"
          value={user.first_name}
          onChange={e =>
            this.setState({
              user: { ...user, [e.target.name]: e.target.value },
            })}
        />

        <Input
          name="last_name"
          label="Last Name"
          value={user.last_name}
          onChange={e =>
            this.setState({
              user: { ...user, [e.target.name]: e.target.value },
            })}
        />

        <Input
          id="email_field"
          name="email"
          label="Email"
          value={user.email}
          onChange={e =>
            this.setState({
              user: { ...user, [e.target.name]: e.target.value },
            })}
        />
        <Checkbox
          label="Notifications"
          description="Receive system notifications by email"
          value={user.can_email}
          onChange={value =>
            this.setState({ user: { ...user, can_email: value } })}
        />

        <h5 className="heading dots">Change Password</h5>

        <Input
          name="password"
          type="password"
          label="New Password"
          value={user.password || ''}
          onChange={e =>
            this.setState({
              user: { ...user, [e.target.name]: e.target.value },
            })}
        />

        <Input
          name="password_confirm"
          type="password"
          label="Verify Password"
          value={user.password_confirm || ''}
          onChange={e =>
            this.setState({
              user: { ...user, [e.target.name]: e.target.value },
            })}
        />

        {localStorage.getItem('user_id') === match.params.id ? (
          <Input
            name="current_password"
            label="Current Password"
            type="password"
            value={user.current_password || ''}
            onChange={e =>
              this.setState({
                user: { ...user, [e.target.name]: e.target.value },
              })}
          />
        ) : null}

        {isAdmin ? (
          <div>
            <h3 className="options heading">Permissions</h3>
            <Select
              name="type"
              label="Type"
              value={role}
              onChange={role =>
                this.setState({
                  role,
                  selectedCompanies: role === 'admin' ? [] : selectedCompanies,
                })}
              items={[
                { value: 'admin', label: 'Global Admin' },
                { value: 'company admin', label: 'Company Admin' },
                { value: 'staff', label: 'Staff' },
                { value: 'user', label: 'User' },
              ]}
            />

            {companies.length > 0 &&
            (role === 'company admin' || role === 'staff') ? (
              <div>
                <h5 className="dots">Companies</h5>
                <div id="admin-cols">
                  <ul id="admin-cols-ul">
                    {companies.map(company => (
                      <li key={company.id}>
                        <input
                          type="checkbox"
                          name={company.name}
                          value={company.id}
                          className="on"
                          checked={
                            selectedCompanies.find(
                              id =>
                                parseInt(id, 10) === parseInt(company.id, 10)
                            ) || ''
                          }
                          onChange={e =>
                            this.toggleCompany(parseInt(e.target.value, 10))}
                        />
                        <label htmlFor="company">{company.name}</label>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}

        {isAdmin ? (
          <div className="options">
            <a
              href="#send"
              onClick={() => {
                if (window.confirm('Are you sure?')) this.sendPassword();
              }}
            >
              Send Password Reset
            </a>
          </div>
        ) : null}
        <div className="options">
          <button
            className="control_button"
            id="save"
            onClick={() => this.save()}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/settings/edit-user.js